import { Tooltip } from "antd";
import { MessageSquareText } from "lucide-react";
import type { PurchaseApprovalItem } from "@/services/APIs/PtsPurchaseApprovalService";

type ReasonCellProps = {
  item: Pick<PurchaseApprovalItem, "management_reason" | "account_reason">;
};

const ReasonCell = ({ item }: ReasonCellProps) => {
  const management = String(item.management_reason ?? "").trim();
  const account = String(item.account_reason ?? "").trim();
  const hasReason = Boolean(management || account);

  if (!hasReason) {
    return (
      <span className="inline-flex h-8 w-8 items-center justify-center text-gray-300">
        <MessageSquareText className="h-4 w-4" />
      </span>
    );
  }

  return (
    <Tooltip
      placement="top"
      color="#ffffff"
      overlayInnerStyle={{
        padding: 0,
        borderRadius: 12,
        border: "1px solid #e5e7eb",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
      }}
      title={
        <div className="min-w-[220px] max-w-[320px] p-3.5 text-left">
          <p className="mb-2.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
            Reason
          </p>
          {management ? (
            <div className={account ? "mb-3" : undefined}>
              <p className="text-[11px] font-semibold text-rose-600">
                Management
              </p>
              <p className="mt-1 text-sm leading-relaxed text-[#111827]">
                {management}
              </p>
            </div>
          ) : null}
          {account ? (
            <div>
              <p className="text-[11px] font-semibold text-sky-600">
                Accountant / IT
              </p>
              <p className="mt-1 text-sm leading-relaxed text-[#111827]">
                {account}
              </p>
            </div>
          ) : null}
        </div>
      }
    >
      <button
        type="button"
        aria-label="View reason"
        className="inline-flex h-8 w-8 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-slate-100 hover:text-[#111827]"
      >
        <MessageSquareText className="h-4 w-4" />
      </button>
    </Tooltip>
  );
};

export default ReasonCell;
